import {SPINNER} from "../../../constants";
import {AbstractDelete} from "../../../clone/dialog/delete";
import {nsFa} from "../../fa/fn";
import i = nsFa.i;
import {nsMessageFlowClone} from "../../../clone/nsMessageFlowClone";

export {template} from "../../../clone/dialog/delete";

export class viewModel extends AbstractDelete {

    protected readonly EVENT_SUCCESS: string = "messagetemplate.delete.success";

    protected override process(): Promise<any> {
        return nsMessageFlowClone.trash(this.params.item);
    }

}
